import { Link } from 'react-router-dom';
import { ScrollSection } from '../components/ScrollSection';

function Corporate() {
  return (
    <>
      {/* Hero Section */}
      <div
        className="container-fluid page-header wow fadeIn"
        data-wow-delay="0.1s"
        style={{
          background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(/img/carousel/physio.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="container text-center py-5 mt-4">
          <h1 className="display-2 text-white fw-bold mb-3 animated slideInDown" style={{ fontFamily: 'Georgia, serif' }}>
            Healthcare access Procedures
          </h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb justify-content-center mb-0">
              <li className="breadcrumb-item fw-bold">
                <Link to="/" className="text-white">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item fw-bold text-white" aria-current="page">
                Healthcare access Procedures
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <div className="container py-5" style={{ maxWidth: '1200px' }}>
        {/* Introductory Section */}
        <ScrollSection>
          <div className="mb-5" style={{ paddingTop: '2rem' }}>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.6', color: '#333', marginBottom: '3rem' }}>
              We're here to help. If you find you have further questions after viewing the links below, please{' '}
              <Link to="/contact" style={{ color: '#0066cc', textDecoration: 'underline' }}>
                contact us
              </Link>.
            </p>
          </div>
        </ScrollSection>

        {/* Information Cards Grid */}
        <ScrollSection>
          <div className="row g-4 mb-5">
            {/* Card 1: Pay cash or momo */}
            <div className="col-md-6 col-lg-4">
              <div
                className="h-100 p-4"
                style={{
                  backgroundColor: '#fff',
                  borderRadius: '8px',
                  border: '1px solid #e0e0e0',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                  transition: 'box-shadow 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
                }}
              >
                <div className="mb-3" style={{ fontSize: '2.5rem', color: '#000' }}>
                  <i className="bi bi-receipt"></i>
                </div>
                <h3 className="mb-3" style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#000' }}>
                  Pay cash or momo
                </h3>
                <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                  • Pay cash or via momo to the bank tellers
                </p>
              </div>
            </div>

            {/* Card 2: Before arriving */}
            <div className="col-md-6 col-lg-4">
              <div
                className="h-100 p-4"
                style={{
                  backgroundColor: '#fff',
                  borderRadius: '8px',
                  border: '1px solid #e0e0e0',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                  transition: 'box-shadow 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
                }}
              >
                <div className="mb-3" style={{ fontSize: '2.5rem', color: '#000' }}>
                  <i className="bi bi-calendar-plus"></i>
                </div>
                <h3 className="mb-3" style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#000' }}>
                  Before arriving
                </h3>
                <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: '1rem' }}>
                  What's smart to address before your visit: make sure your insurance is active and other items to consider.
                </p>
                <Link to="/before-arriving" style={{ color: '#0066cc', textDecoration: 'underline', fontSize: '1rem' }}>
                  Find out more <i className="bi bi-arrow-right"></i>
                </Link>
              </div>
            </div>

            {/* Card 3: Accepted insurances */}
            <div className="col-md-6 col-lg-4">
              <div
                className="h-100 p-4"
                style={{
                  backgroundColor: '#fff',
                  borderRadius: '8px',
                  border: '1px solid #e0e0e0',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                  transition: 'box-shadow 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
                }}
              >
                <div className="mb-3" style={{ fontSize: '2.5rem', color: '#000' }}>
                  <i className="bi bi-file-check"></i>
                </div>
                <h3 className="mb-3" style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#000' }}>
                  Accepted insurances
                </h3>
                <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: '1rem' }}>
                  Tema General Hospital has established partnerships with several healthcare insurance providers. Find out if your insurance is accepted, and what your next steps are.
                </p>
                <Link to="/donors-partners" style={{ color: '#0066cc', textDecoration: 'underline', fontSize: '1rem' }}>
                  Does TGH accept my insurance? <i className="bi bi-arrow-right"></i>
                </Link>
              </div>
            </div>

            {/* Card 4: Insurance & self-pay */}
            <div className="col-md-6 col-lg-4">
              <div
                className="h-100 p-4"
                style={{
                  backgroundColor: '#fff',
                  borderRadius: '8px',
                  border: '1px solid #e0e0e0',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                  transition: 'box-shadow 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
                }}
              >
                <div className="mb-3" style={{ fontSize: '2.5rem', color: '#000' }}>
                  <i className="bi bi-file-plus"></i>
                </div>
                <h3 className="mb-3" style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#000' }}>
                  Insurance & self-pay
                </h3>
                <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: '1rem' }}>
                  TGH's insurance process, types accepted, options for uninsured patients, guidance on insurer-denied claims and FAQs.
                </p>
                <Link to="/insurance-self-pay" style={{ color: '#0066cc', textDecoration: 'underline', fontSize: '1rem' }}>
                  Find out more <i className="bi bi-arrow-right"></i>
                </Link>
              </div>
            </div>

            {/* Card 5: Bills & payments */}
            <div className="col-md-6 col-lg-4">
              <div
                className="h-100 p-4"
                style={{
                  backgroundColor: '#fff',
                  borderRadius: '8px',
                  border: '1px solid #e0e0e0',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                  transition: 'box-shadow 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
                }}
              >
                <div className="mb-3" style={{ fontSize: '2.5rem', color: '#000', fontWeight: 'bold' }}>
                  ₵
                </div>
                <h3 className="mb-3" style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#000' }}>
                  Bills & payments
                </h3>
                <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: '1rem' }}>
                  Viewing and paying bills, TGH's billing process, understanding your TGH bill, and more.
                </p>
                <Link to="/bills-payments" style={{ color: '#0066cc', textDecoration: 'underline', fontSize: '1rem' }}>
                  Find out more <i className="bi bi-arrow-right"></i>
                </Link>
              </div>
            </div>
          </div>
        </ScrollSection>
      </div>
    </>
  );
}

export default Corporate;




